import * as FC from "@fluentui/react-components";
import { useContext, useEffect, useState } from "react";
import { Context } from "../context";
import { TableDef } from "../table_def";
import { toDateString, toDateTimeString } from "../date_utils";
import { apiClient } from "./api";

export const field_item_searchable_columns = [
    "seq",
    "name",
    "type", // Updated from 'typ' to match backend API
    "contact",
    "contact_phone",
    "address",
    "description",
];

export const listFieldItem = async (filter) => {
    try {
        const items = await apiClient.getFieldItems();
        
        // Apply client-side filtering if needed
        if (filter && filter.trim()) {
            const filterLower = filter.toLowerCase();
            return items.filter(item => 
                field_item_searchable_columns.some(column => 
                    item[column]?.toString().toLowerCase().includes(filterLower)
                )
            );
        }
        
        return items;
    } catch (error) {
        console.error("Failed to load field items:", error);
        return [];
    }
};

/**
 * @param {import("@fluentui/react-components").DropdownProps} props
 */
export const FieldItemDropdown = (props) => {
    const { apiClient } = useContext(Context);
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);

    const loadFieldItems = async () => {
        setLoading(true);
        try {
            const items = await listFieldItem();
            setItems(items);
        } catch (error) {
            console.error("Failed to load field items:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadFieldItems();
    }, []);

    return (
        <FC.Dropdown {...props} disabled={loading}>
            <FC.Option value="">全部</FC.Option>
            {items.map((item) => (
                <FC.Option key={item.id} value={item.id}>
                    {item.name}
                </FC.Option>
            ))}
        </FC.Dropdown>
    );
};

export const FieldItemDef = new TableDef("field_item", {
    seq: {
        label: "风场编号",
    },
    name: {
        label: "风场名称",
    },
    type: { // Updated from 'typ' to match backend API
        label: "风场类型",
    },
    power: {
        label: "装机容量(MW)",
    },
    address: {
        label: "地址",
    },
    contact: {
        label: "联系人",
    },
    contact_phone: {
        label: "联系电话",
    },
    built_at: {
        label: "修建于",
        display: (item) => toDateString(item.built_at),
    },
    updated_at: {
        label: "更新于",
        display: (item) => toDateTimeString(item.updated_at),
    },
});